export const primaryCtaClass =

  "inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-yellow-300 via-primary to-amber-300 text-secondary shadow-md shadow-primary/30 ring-1 ring-amber-200/60 transition hover:scale-[1.02] hover:from-yellow-200 hover:via-yellow-300 hover:to-amber-200 hover:shadow-lg hover:shadow-primary/50";

